module.exports = __webpack_public_path__ + "img/banner-3.13107ba6.png";